// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"60":"Maquillaje","301":"Snacks","411":"Sets","455":"Lifestyle","783":"Perfumes"}[chunkId] + "." + {"60":"a862799d","301":"431163c3","411":"dae49019","455":"9c4464b0","783":"eaa345f0"}[chunkId] + ".js";
};